/**
 * @generated SignedSource<<87f72f29b55801b2b66c2c33fd2deb92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetContactAttributeInput = {
  attributeName: string;
  id: string;
  value: string;
};
export type ContactAttributesPanelSetContactAttributeMutation$variables = {
  input: SetContactAttributeInput;
};
export type ContactAttributesPanelSetContactAttributeMutation$data = {
  readonly setContactAttribute: {
    readonly attributes: ReadonlyArray<{
      readonly name: string;
      readonly value: string;
    }>;
    readonly id: string;
  };
};
export type ContactAttributesPanelSetContactAttributeMutation = {
  response: ContactAttributesPanelSetContactAttributeMutation$data;
  variables: ContactAttributesPanelSetContactAttributeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ContactAttribute",
  "kind": "LinkedField",
  "name": "attributes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactAttributesPanelSetContactAttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setContactAttribute",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactAttributesPanelSetContactAttributeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setContactAttribute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d65e22b12613c0721f4a3e5cf8976989",
    "id": null,
    "metadata": {},
    "name": "ContactAttributesPanelSetContactAttributeMutation",
    "operationKind": "mutation",
    "text": "mutation ContactAttributesPanelSetContactAttributeMutation(\n  $input: SetContactAttributeInput!\n) {\n  setContactAttribute(input: $input) {\n    __typename\n    id\n    attributes {\n      name\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "720b4c45e4ddfe7d3db2207672cc8a36";

export default node;
